// extracted by mini-css-extract-plugin
module.exports = {"agendaTitleContainer":"AgendaPage_agendaTitleContainer__27Pkn","agendaTitle":"AgendaPage_agendaTitle__2eF24","selectProviderButton":"AgendaPage_selectProviderButton__2tKEf"};